module.exports = __webpack_public_path__ + "/static/assets/2f9cda00a530ac237fc24063067377c3.svg";